"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DuplicateRequestInterceptor = void 0;
const RequestInterceptor_1 = require("./RequestInterceptor");
class DuplicateRequestInterceptor extends RequestInterceptor_1.RequestInterceptor {
    constructor(duplicateRequestDetector, axios) {
        super(axios);
        this.duplicateRequestDetector = duplicateRequestDetector;
        this.duplicateRequestDetector = duplicateRequestDetector;
    }
    onFulfilled(config) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this.duplicateRequestDetector.detect(config);
            }
            catch (e) {
                return this.rejectRequest(config, e.message);
            }
            return config;
        });
    }
}
exports.DuplicateRequestInterceptor = DuplicateRequestInterceptor;
